// The language UI controls (kept out of index.ts to avoid a cycle with brand/dom).
import { getLang, setLang, LANGS, LANG_META, type Lang, t } from "./index.ts";

/** A compact cycling language button for the top nav + login card. Shows the
 *  CURRENT language code; click cycles to the next language. */
export function languageToggle(): HTMLButtonElement {
  const b = document.createElement("button");
  b.type = "button";
  b.className = "btn ghost icon lang-toggle";
  const paint = () => {
    const cur = getLang();
    b.textContent = LANG_META[cur].short;
    const label = t("settings.language") + ": " + LANG_META[cur].label;
    b.setAttribute("aria-label", label);
    b.title = label;
  };
  paint();
  b.addEventListener("click", () => {
    const i = LANGS.indexOf(getLang());
    setLang(LANGS[(i + 1) % LANGS.length]);   // persists + reloads
  });
  return b;
}

/** A native <select> for Settings (English / Slovenščina). */
export function languageSelect(): HTMLElement {
  const field = document.createElement("label");
  field.className = "field";
  field.innerHTML =
    `<span>${t("settings.language")}</span>` +
    `<select name="lang">` +
    LANGS.map((l) => `<option value="${l}">${LANG_META[l].label}</option>`).join("") +
    `</select>`;
  const select = field.querySelector("select")!;
  select.value = getLang();
  select.addEventListener("change", () => setLang(select.value as Lang));
  return field;
}
